import Vue from 'vue'
import VueRouter from 'vue-router'
import { Role } from '@/utils/role'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/AuthView'),
    meta: { layout: 'AuthLayout' }
  },
  {
    path: '/restore-password',
    name: 'restore-password',
    component: () => import('@/views/RestorePasswordView'),
    meta: { layout: 'AuthLayout' }
  },
  {
    path: '/login/verify',
    name: 'verify',
    component: () => import('@/views/VerifyEmailView'),
    meta: { layout: 'AuthLayout' }
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('@/views/RegistrationView'),
    meta: { layout: 'AuthLayout' }
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/AdminUsersView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/agents',
    name: 'agents',
    component: () => import('@/views/AdminAgentsView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/referrals',
    name: 'referrals',
    component: () => import('@/views/ReferralsView'),
    meta: { layout: 'MainLayout', authorize: [Role.User, Role.Admin] }
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('@/views/ReportView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/miners',
    name: 'miners',
    component: () => import('@/views/UserMinersView'),
    meta: { layout: 'MainLayout', authorize: [Role.User] }
  },
  {
    path: '/subusers',
    name: 'subusers',
    component: () => import('@/views/SubusersView'),
    meta: { layout: 'MainLayout', authorize: [Role.User] }
  },
  {
    path: '/devices',
    name: 'devices',
    component: () => import('@/views/AdminMinersView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/pools',
    name: 'pools',
    component: () => import('@/views/AdminPoolsView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/rank',
    name: 'rank',
    component: () => import('@/views/AdminRankView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/telegram',
    name: 'telegram',
    component: () => import('@/views/AdminTelegramView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: () => import('@/views/WalletView'),
    meta: { layout: 'MainLayout', authorize: [Role.User] }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/SettingsView'),
    meta: { layout: 'MainLayout', authorize: [Role.User] }
  },
  {
    path: '/finance',
    name: 'finance',
    component: () => import('@/views/FinanceView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/transaction',
    name: 'transaction',
    component: () => import('@/views/AdminTransactionView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/coreproxy',
    name: 'coreproxy',
    component: () => import('@/views/CoreProxyView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/email',
    name: 'email',
    component: () => import('@/views/EmailView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/rub-withdrawal',
    name: 'rub-withdrawal',
    component: () => import('@/views/RubWithdrawalView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/treasury',
    name: 'treasury',
    component: () => import('@/views/TreasuryView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '/corporate-wallets',
    name: 'corporateWallets',
    component: () => import('@/views/CorporateWalletsView'),
    meta: { layout: 'MainLayout', authorize: [Role.Admin] }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const { authorize } = to.meta
  if (authorize) {
    const currentUser = JSON.parse(localStorage.getItem('user'))
    if (!currentUser) {
      return next({ name: 'login' })
    }
    // Role-based routing removed: backend API enforces authorization (C9/H22)
  }
  next()
})

export default router
